export default "__VITE_ASSET__CAnfgyjy__"